export const ssoLoginAPI = `api/Login/ValidateSSOUser`;
export const dealerDataUpdateAPI = `api/DBUpdate`;